import { $emit, $once } from "@utils/events";
import appBridge, { baseParentInvoke } from "@utils/appBridge";
import { getRandomId, isObject } from "@utils/utils";


/**
 *
 * @param clientMethods
 * @param eventName
 * @param f
 * @param params 调用的app那边的方法的入参，对象格式
 */
export const clientBaseEvent = ({ clientMethods, eventName, f, params = {} }) => {
    const _id = getRandomId();
    appBridge[clientMethods]({ ...params, _id });
    if (!eventName) return;
    $once(eventName, async (options) => {
        try {
            let _options = JSON.parse(options);
            if (_options._id === _id) {
                f && await f(_options);
            }
        } catch (e) {
            console.error(e);
        }
    })
}

/**
 *
 * @param callClientName - 调用的app那边的方法
 * @param callBackName - app回调的方法名
 * @param eventName - 该事件唯一事件 key
 * @returns {*|(function({}=, *): void)}
 */
export const registerClientMethods = ({ callClientName, callBackName, eventName }) => {
    if (callBackName && eventName) {
        window[callBackName] = (options) => {
            $emit(eventName, options)
        }
    }

    appBridge[callClientName] = (params) => {
        try {
            return baseParentInvoke(callClientName, params)
        } catch (e) {
            console.error(e)
            return ''
        }
    }

    /**
     * params 传给app的参数，必须是对象
     */
    return (params = {}, f) => {
        let _params = params;
        let _f = f;
        if (!isObject(_params)) {
            _f = _params;
            _params = {}
        }
        clientBaseEvent({
            clientMethods: callClientName,
            eventName: eventName,
            f: _f,
            params: _params
        });
    }
}
